import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { DEFAULT_FONT_FAMILY } from '@constants/common/ui.constants';

interface Params {
  isError: boolean;
}

const useStyles = makeStyles<Params>()((theme, { isError }) => ({
  root: {
    width: '100%',
    position: 'relative',
  },

  formControl: {
    width: '100%',
  },
  disabledBox: {
    opacity: 0.48,
    pointerEvents: 'none',

    '& .MuiFormHelperText-root': {
      span: {
        color: theme.palette.custom.text.accent,
      },
    },
  },
  input: {
    background: theme.palette.custom.elements.primary,
    transition: 'all 0.25s ease-in-out',
    borderRadius: theme.borderRadius.xl,

    '& input': {
      boxSizing: 'border-box',
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 400,
      fontFamily: DEFAULT_FONT_FAMILY,
      color: theme.palette.custom.text.accent,
      height: 45,
      borderRadius: theme.borderRadius.xl,

      '&.MuiInputBase-inputSizeSmall': {
        height: 44,
        minHeight: 44,
      },

      '&::placeholder': {
        fontSize: 16,
        color: theme.palette.custom.text.dark,
        opacity: 1,
      },

      '&:focus': {
        caretColor: theme.palette.custom.text.accent,
        backgroundColor: theme.palette.custom.elements.primaryHover,
      },

      '&:hover': {
        color: theme.palette.custom.text.dark,
        backgroundColor: theme.palette.custom.elements.primaryHover,
      },
    },

    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.custom.border.primary}`,
        borderRadius: theme.borderRadius.xl,
        color: theme.palette.custom.text.accent,

        '& input': {
          color: theme.palette.custom.text.accent,
        },
      },

      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',

        '& input': {
          color: theme.palette.custom.text.accent,
        },
      },
    },

    '&:hover': {
      '& input': {
        color: theme.palette.custom.text.accent,

        '&::placeholder': {
          color: theme.palette.custom.text.dark,
        },
      },

      '& .MuiSvgIcon-root': {
        color: theme.palette.custom.text.accent,
      },
    },
  },
  supportText: {
    paddingTop: 4,
    lineHeight: 1,
  },

  error: {
    right: 0,
    marginRight: 'auto',

    '& span': {
      color: theme.palette.custom.accent.error,
    },
  },
  errorBox: {
    '.MuiFormLabel-root': {
      color: theme.palette.custom.text.accent,
    },

    '&:hover .MuiFormLabel-root': {
      color: theme.palette.custom.text.accent,
    },

    '& .MuiFormLabel-root': {
      color: theme.palette.custom.text.dark,

      '&.Mui-focused': {
        color: theme.palette.custom.text.accent,
        backgroundColor: theme.palette.custom.elements.primaryHover,
      },
    },

    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: theme.borderRadius.xl,
        borderColor: theme.palette.custom.accent.error,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.accent.error,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.custom.accent.error} !important`,
      },
    },

    '& input': {
      color: theme.palette.custom.text.accent,
      caretColor: `${theme.palette.custom.text.accent} !important`,
    },
  },

  buttonMax: {
    textTransform: 'capitalize',
    backgroundColor: 'transparent',
    border: 'none',
    color: theme.palette.custom.text.dark,
    cursor: 'pointer',

    '&:hover': {
      opacity: '0.7',
    },

    '&:active': {
      opacity: '0.5',
    },

    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.38,
    },
  },

  searchIcon: {
    ...dFlex(),
    color: theme.palette.custom.text.accent,
    width: 28,
  },
  actionsBox: {
    ...dFlex(),
    gap: 12,
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translate(0, -50%)',

    ...(isError && {
      top: '33%',
      transform: 'translate(0, -50%)',
    }),
  },
}));

export default useStyles;
